import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from 'src/pages/home';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import NotFound from '@/pages/not-found';
import Login from '@/pages/login';
import Receipt from '@/pages/receipt';
import CommonModal from '@/components/shared/commen-modal';
import XBottomSheet from '@/components/@base/x-bottom-sheet';

const Router = () => (
  <BrowserRouter>
    <CommonModal />
    <XBottomSheet/>
    <Routes>
      <Route
        path='/'
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />
      <Route
        path='/login'
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path='/receipt'
        element={
          <PublicRoute>
            <Receipt />
          </PublicRoute>
        }
      />
      <Route path='*' element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default Router;
